import ResourceApi from '../ResourceApi';

const ShoutoutsResource = {
  index: async (params = {}) => (await ResourceApi.get('/resource/shoutouts', params)).data,
};

export default ShoutoutsResource;
